import flatMap from 'lodash/flatMap';
import groupBy from 'lodash/groupBy';
import {mapDataType} from 'constants/FilterConstants';
import {selectCardById} from 'state/card/cardSelectors';

export const selectDataSources = (state) => state.dataSource.dataSources;

export const selectDataSourceById = (state, dataSourceId) =>
  selectDataSources(state)[dataSourceId];

export const selectDataSourceIdByCardId = (state, cardId) => {
  const cardDataSourceIds = state.dataSource.byCardId[cardId];
  return cardDataSourceIds && cardDataSourceIds[0];
};

export const selectDataSourceByCardId = (state, cardId) => {
  const cardDataSourceIds = state.dataSource.byCardId[cardId];
  const dataSourceId = cardDataSourceIds && cardDataSourceIds[0];
  return selectDataSourceById(state, dataSourceId);
};

const EMPTY_FILTER_GROUPS = [];
export const selectFilterGroups = (state, dataSourceId) =>
  state.dataSource.filterGroups[dataSourceId] || EMPTY_FILTER_GROUPS;

export const selectHasFilterGroups = (state, cardId) => {
  if (!cardId) return false;

  const cardDataSourceIds = state.dataSource.byCardId[cardId] || [];
  const cardFilterGroups = cardDataSourceIds.map((id) =>
    selectFilterGroups(state, id)
  );
  return cardFilterGroups.some((group) => group && group.length > 0);
};

export const selectFilterableColumns = (state, dataSourceIds) => {
  const dataSources = dataSourceIds
    .map((id) => selectDataSourceById(state, id))
    .filter(Boolean);
  const rawColumns = flatMap(dataSources, (ds) =>
    ds.columns.map((column) => ({
      ...column,
      dataSourceId: ds.id,
      dataType: mapDataType(column.type),
    }))
  );

  const groupedColumns = groupBy(
    rawColumns,
    (column) => `${column.name}:${column.dataType}`
  );
  const mergedColumns = Object.values(groupedColumns).map((columns) => ({
    ...columns[0],
    dataSourceIds: columns.map((c) => c.dataSourceId),
  }));

  return mergedColumns;
};

export const selectFilterableColumnsByCardId = (state, cardId) => {
  const card = selectCardById(state, cardId);
  const dataSourceIds = card
    ? card.datasources.map((ds) => ds.dataSourceId)
    : [];
  return selectFilterableColumns(state, dataSourceIds);
};
